// este archivo tiene un fucnion que extrae el nombre de archivos guardados en firebase a partir de la url, por ejemplo, si la url es https://firebasestorage.googleapis.com/v0/b/biolab-8c9e7.appspot.com/o/propuestas%2F69e2f58d8447378263fbdeeb%2FActa_A-uu4-1.pdf?alt=media&token=1234567890abcdef, la función extrae el nombre Acta_A-uu4-1.pdf

function extraerNombreArchivo(url) {
  const u = new URL(url);
  const objetoCodificado = u.pathname.split('/o/')[1]; // lo que va después de /o/
  const rutaReal = decodeURIComponent(objetoCodificado);
  return rutaReal.split('/').pop();
}

export default extraerNombreArchivo;